import base from 'base-x';

const base58Alphabet =
  '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

const base58 = base(base58Alphabet);

const UUID_BYTE_LENGTH = 16;
const MIN_BASE58_UUID_LENGTH = 16;
const MAX_BASE58_UUID_LENGTH = 22;

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const bth: string[] = [];

for (let i = 0; i < 256; i++) {
  bth[i] = (i + 0x100).toString(16).slice(1);
}

export function uuidToBase58(s: string): string {
  return base58.encode(parseUuid(s));
}

export function base58ToUuid(s: string): string {
  if (typeof s !== 'string') {
    throw new TypeError('Expected string');
  }

  // Cheap rejection before running base-x decode.
  // Valid base-x encodings of exactly 16 UUID bytes are 16..22 chars.
  if (s.length < MIN_BASE58_UUID_LENGTH || s.length > MAX_BASE58_UUID_LENGTH) {
    throw new TypeError(`Invalid base58 UUID length: ${s.length}`);
  }

  const bytes = base58.decode(s);

  if (bytes.length !== UUID_BYTE_LENGTH) {
    throw new TypeError(`Invalid base58 UUID byte length: ${bytes.length}`);
  }

  return stringifyUuid(bytes);
}

function stringifyUuid(arr: Uint8Array): string {
  if (!(arr instanceof Uint8Array)) {
    throw new TypeError('Expected Uint8Array');
  }

  if (arr.length !== UUID_BYTE_LENGTH) {
    throw new TypeError('Expected 16 bytes');
  }

  return (
    bth[arr[0]] +
    bth[arr[1]] +
    bth[arr[2]] +
    bth[arr[3]] +
    '-' +
    bth[arr[4]] +
    bth[arr[5]] +
    '-' +
    bth[arr[6]] +
    bth[arr[7]] +
    '-' +
    bth[arr[8]] +
    bth[arr[9]] +
    '-' +
    bth[arr[10]] +
    bth[arr[11]] +
    bth[arr[12]] +
    bth[arr[13]] +
    bth[arr[14]] +
    bth[arr[15]]
  );
}

function parseUuid(s: string): Uint8Array {
  if (!uuidRegex.test(s)) {
    throw new TypeError('Invalid uuid');
  }

  const hex = s.replaceAll('-', '');
  const arr = new Uint8Array(UUID_BYTE_LENGTH);

  for (let i = 0; i < UUID_BYTE_LENGTH; i++) {
    arr[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }

  return arr;
}
